import React, { useState, useEffect, useRef } from 'react';
import { useStateValue } from './StateProvider.js';
import ReactToPrint from 'react-to-print';
import axios from 'axios';
import configData from './Config';
import Select from './Components/select.js';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { numberToWords } from './Utils/textparse.js';
import moment from 'moment';

import { getPermission } from './Utils/permissions.js';
import Title from './Title.js';

import './Payslips.css';

export const accountTypes = [
    { id: 'asset', name: 'Asset' },
    { id: 'liability', name: 'Liability' },
    { id: 'equity', name: 'Equity' },
    { id: 'income', name: 'Income' },
    { id: 'expense', name: 'Expense' },
];

function Payroll({ state, setState }) {
    const [{ project }, dispatch] = useStateValue();

    const [filteredpayslips, setFilteredpayslips] = useState([]);
    const [search, setSearch] = useState('');
    const [order, setOrder] = useState('');

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    useEffect(() => {
        let filtered = project.payslips.filter((payslip) =>
            payslip.name.toLowerCase().includes(search.toLowerCase())
        );

        setFilteredpayslips(filtered);
    }, [project, search]);

    const closeButton = () => {
        setState(state => ({ ...state, modalopen: false, modalcontent: null, modaltype: null, modaltitle: null }));
    }

    const addButton = () => {
        setState(state => ({ ...state, modalopen: true, modalcontent: <AddPayslip />, modaltype: 'large', modaltitle: 'Add Payslip' }));
    }

    const editButton = (payslip) => {
        setState(state => ({ ...state, modalopen: true, modalcontent: <EditPayslip payslip={payslip} mode='edit' />, modaltype: 'large', modaltitle: 'Edit Payslip' }));
    }

    const cloneButton = (payslip) => {
        setState(state => ({ ...state, modalopen: true, modalcontent: <EditPayslip payslip={payslip} mode='clone' />, modaltype: 'large', modaltitle: 'Edit Payslip' }));
    }

    const removeButton = (payslip) => {
        setState(state => ({ ...state, modalopen: true, modalcontent: <RemovePayslip payslip={payslip} />, modaltype: 'small', modaltitle: 'Remove Payslip' }));
    }

    const viewButton = (payslip) => {
        setState(state => ({ ...state, modalopen: true, modalcontent: <ViewPayslip payslip={payslip} />, modaltype: 'large', modaltitle: 'View Payslip' }));
    }

    const addPayslip = (project, ts, staffid, currencyid, name, earnings, deductions, contributions, liabilityaccountid, setLoading, setResult) => {
        console.log('Trying to add payslip');

        setResult('');

        const hasPermission = getPermission(
            project.projectuserid,
            project.users,
            state.user.userid,
            'Payroll',
            'add',
            project.archived
        );
        if (hasPermission.code == 0) {
            setResult(hasPermission.data);
            return;
        }

        if (!name || !currencyid) {
            setResult('Missing info');
            return;
        }

        setLoading(true);

        const trimmedName = name.trim();

        const data = {
            projectuserid: project.projectuserid,
            projectid: project.projectid,
            ts: ts,
            staffid: staffid,
            currencyid: currencyid,
            name: trimmedName,
            earnings: earnings,
            deductions: deductions,
            contributions: contributions,
            liabilityaccountid: liabilityaccountid
        }

        axios.post(configData.CONTROLLERURL + configData.ADDPAYSLIP, data, {
            headers: {
                "Accept": "application/json",
                "Content-Type": "application/json;charset=UTF-8",
                "userid": state.user.userid,
                "usertoken": state.user.usertoken
            }
        }).then((res) => {
            console.log('Add transaction data received')
            console.log(res.data)
            if (res.data instanceof Object) {
                if (res.data.code === 1) {
                    data.id = res.data.id;
                    dispatch({
                        type: 'ADD_PAYSLIP',
                        payslip: data
                    });
                    closeButton();
                }
                else {
                    setResult(res.data.data);
                }
            }
            else {
                setResult('Error');
            }
        }).catch((err) => {
            setResult(err.response?.data?.message || err.message || 'Network error');
        }).finally(() => {
            setLoading(false);
            setSearch('')
        });
    }

    const updatePayslip = (project, id, ts, staffid, currencyid, name, earnings, deductions, contributions, liabilityaccountid, setLoading, setResult) => {
        console.log('Trying to add payslip');

        setResult('');

        const hasPermission = getPermission(
            project.projectuserid,
            project.users,
            state.user.userid,
            'Payroll',
            'update',
            project.archived
        );
        if (hasPermission.code == 0) {
            setResult(hasPermission.data);
            return;
        }

        if (!name || !currencyid) {
            setResult('Missing info');
            return;
        }

        setLoading(true);

        const trimmedName = name.trim();

        const data = {
            projectuserid: project.projectuserid,
            projectid: project.projectid,
            id: id,
            ts: ts,
            staffid: staffid,
            name: trimmedName,
            earnings: earnings,
            deductions: deductions,
            contributions: contributions,
            currencyid: currencyid,
            liabilityaccountid: liabilityaccountid
        }

        axios.post(configData.CONTROLLERURL + configData.UPDATEPAYSLIP, data, {
            headers: {
                "Accept": "application/json",
                "Content-Type": "application/json;charset=UTF-8",
                "userid": state.user.userid,
                "usertoken": state.user.usertoken
            }
        }).then((res) => {
            console.log('Add payslip data received')
            console.log(res.data)
            if (res.data instanceof Object) {
                if (res.data.code === 1) {
                    data.id = res.data.id;
                    dispatch({
                        type: 'UPDATE_PAYSLIP',
                        payslip: data
                    });
                    closeButton();
                }
                else {
                    setResult(res.data.data);
                }
            }
            else {
                setResult('Error');
            }
        }).catch((err) => {
            setResult(err.response?.data?.message || err.message || 'Network error');
        }).finally(() => {
            setLoading(false);
            setSearch('')
        });
    }

    const removePayslip = (project, id, setLoading, setResult) => {
        console.log('Trying to remove payslip');

        const hasPermission = getPermission(
            project.projectuserid,
            project.users,
            state.user.userid,
            'Payroll',
            'remove',
            project.archived
        );
        if (hasPermission.code == 0) {
            setResult(hasPermission.data);
            return;
        }

        setLoading(true);

        const data = {
            projectuserid: project.projectuserid,
            projectid: project.projectid,
            id: id
        }

        axios.post(configData.CONTROLLERURL + configData.REMOVEPAYSLIP, data, {
            headers: {
                "Accept": "application/json",
                "Content-Type": "application/json;charset=UTF-8",
                "userid": state.user.userid,
                "usertoken": state.user.usertoken
            }
        }).then((res) => {
            console.log('Remove item data received')
            console.log(res.data)
            if (res.data instanceof Object) {
                if (res.data.code === 1) {
                    dispatch({
                        type: 'REMOVE_PAYSLIP',
                        payslipid: id
                    });
                    closeButton();
                }
                else {
                    setResult(res.data.data)
                }
            }
            else {
                setResult('Error')
            }
        }).catch((err) => {
            setResult(err.response?.data?.message || err.message || 'Network error');
        }).finally(() => {
            setLoading(false);
        });
    }

    function NewRow({ row, index, data, setData }) {
        const handleAccountTypeChange = (newType) => {
            const updated = [...data];
            updated[index].accounttype = newType;
            setData(updated);
        };

        const handleAccountChange = (accountId) => {
            const updated = [...data];
            updated[index].accountid = accountId;
            setData(updated);
        };

        const handleAmountChange = (e) => {
            const updated = [...data];
            updated[index].amount = parseFloat(e.target.value) || 0;
            setData(updated);
        };

        const handleRemoveRow = () => {
            const updated = [...data];
            updated.splice(index, 1);
            setData(updated);
        };

        const renderAccountOptions = () => {
            const accountsByType = {
                asset: project.assetaccounts,
                liability: project.liabilityaccounts,
                equity: project.equityaccounts,
                income: project.incomeaccounts,
                expense: project.expenseaccounts,
            };

            const options = accountsByType[row.accounttype] || [];

            return (
                <Select
                    data={options}
                    itemid={row.accountid}
                    setItemid={(accountId) => handleAccountChange(accountId)}
                />
            );
        };

        return (
            <tr>
                <td>
                    <Select data={accountTypes} itemid={row.accounttype} setItemid={(accountType) => handleAccountTypeChange(accountType)} />
                </td>
                <td>{renderAccountOptions()}</td>
                <td>
                    <input
                        className='modal_input'
                        type="text"
                        placeholder={0}
                        value={row.amount}
                        onChange={handleAmountChange}
                    />
                </td>
                <td>
                    <div className='modal_removeitembutton' onClick={handleRemoveRow}>&minus;</div>
                </td>
            </tr>
        );
    }

    const handleAddEarning = (earnings, setEarnings) => {
        setEarnings([...earnings, { accounttype: '', accountid: '', amount: 0 }])
    }

    const handleAddDeduction = (deductions, setDeductions) => {
        setDeductions([...deductions, { accounttype: '', accountid: '', amount: 0 }])
    }

    const handleAddContribtion = (contributions, setContributions) => {
        setContributions([...contributions, { accounttype: '', accountid: '', amount: 0 }])
    }

    function AddPayslip() {
        const [selecteddate, setSelecteddate] = useState(new Date());
        const [ts, setTs] = useState(0);
        const [currencyid, setCurrencyid] = useState('');
        const [name, setName] = useState('');

        const [staffid, setStaffid] = useState('');
        const [earnings, setEarnings] = useState([{ accounttype: 'expenseaccounts', accountid: '', amount: 0 }]);
        const [deductions, setDeductions] = useState([]);
        const [contributions, setContributions] = useState([]);
        const [liabilityaccountid, setLiabilityaccountid] = useState('');

        const [result, setResult] = useState(null);
        const [loading, setLoading] = useState(false);

        useEffect(() => {
            const unixTimestamp = Math.floor(selecteddate.getTime() / 1000);
            setTs(unixTimestamp);
        }, [selecteddate]);

        return (
            <div className='modal_body'>
                <div className='modal_printable'>
                    <div className="modal_row">
                        <div className='modal_rowsection'>
                            <div className='modal_label'>Date</div>
                        </div>
                        <div className='modal_rowsection'>
                            <DatePicker
                                className='modal_datepicker'
                                selected={selecteddate}
                                onChange={(date) => setSelecteddate(date)}
                                dateFormat="dd/MM/yyyy"
                            />
                        </div>
                    </div>
                    <div className="modal_row">
                        <div className='modal_rowsection'>
                            <div className='modal_label'>Staff</div>
                        </div>
                        <div className='modal_rowsection'>
                            <Select data={project.staff} itemid={staffid} setItemid={setStaffid} />
                        </div>
                    </div>
                    <div className="modal_row">
                        <div className='modal_rowsection'>
                            <div className='modal_label'>Currency</div>
                        </div>
                        <div className='modal_rowsection'>
                            <Select data={project.currencies} itemid={currencyid} setItemid={setCurrencyid} />
                        </div>
                    </div>
                    <div className="modal_row">
                        <div className='modal_rowsection'>
                            <div className='modal_label'>Name</div>
                        </div>
                        <div className='modal_rowsection'>
                            <input
                                className='modal_input'
                                type="text"
                                value={name}
                                onChange={e => setName(e.target.value)}
                            />
                        </div>
                    </div>
                    <div className="modal_row">
                        <div className='modal_rowsection'>
                            <div className='modal_label'>Liability account</div>
                        </div>
                        <div className='modal_rowsection'>
                            <Select data={project.liabilityaccounts} itemid={liabilityaccountid} setItemid={setLiabilityaccountid} />
                        </div>
                    </div>
                    <div className="modal_row">
                        <div className='modal_rowsection'>
                            <div className='modal_label'>Earnings</div>
                        </div>
                    </div>
                    <div className="modal_row">
                        <div className='modal_rowsection'>
                            <table className='modal_table'>
                                <thead><tr><th>Type</th><th>Account</th><th>Amount</th><th></th></tr></thead>
                                <tbody>
                                    {
                                        earnings.map((row, index) => (
                                            <NewRow
                                                key={'earning' + index}
                                                row={row}
                                                index={index}
                                                data={earnings}
                                                setData={setEarnings}
                                            />
                                        ))
                                    }
                                </tbody>
                                <tfoot>
                                    <tr>
                                    </tr>
                                </tfoot>
                            </table>
                        </div>
                    </div>
                    <div className='modal_actions'>
                        <div className='modal_buttons'>
                            <div className='modal_buttoncontainer'>
                                <button className='modal_button' onClick={() => handleAddEarning(earnings, setEarnings)}>Add row</button>
                            </div>
                            <div className='modal_buttoncontainer'></div>
                        </div>
                    </div>
                    <div className="modal_row">
                        <div className='modal_rowsection'>
                            <div className='modal_label'>Deductions</div>
                        </div>
                    </div>
                    <div className="modal_row">
                        <div className='modal_rowsection'>
                            <table className='modal_table'>
                                <thead><tr><th>Type</th><th>Account</th><th>Amount</th><th></th></tr></thead>
                                <tbody>
                                    {
                                        deductions.map((row, index) => (
                                            <NewRow
                                                key={'deduction' + index}
                                                row={row}
                                                index={index}
                                                data={deductions}
                                                setData={setDeductions}
                                            />
                                        ))
                                    }
                                </tbody>
                                <tfoot>
                                    <tr>
                                    </tr>
                                </tfoot>
                            </table>
                        </div>
                    </div>
                    <div className='modal_actions'>
                        <div className='modal_buttons'>
                            <div className='modal_buttoncontainer'>
                                <button className='modal_button' onClick={() => handleAddEarning(deductions, setDeductions)}>Add row</button>
                            </div>
                            <div className='modal_buttoncontainer'></div>
                        </div>
                    </div>
                    <div className="modal_row">
                        <div className='modal_rowsection'>
                            <div className='modal_label'>Contributions</div>
                        </div>
                    </div>
                    <div className="modal_row">
                        <div className='modal_rowsection'>
                            <table className='modal_table'>
                                <thead><tr><th>Type</th><th>Account</th><th>Amount</th><th></th></tr></thead>
                                <tbody>
                                    {
                                        contributions.map((row, index) => (
                                            <NewRow
                                                key={'contribution' + index}
                                                row={row}
                                                index={index}
                                                data={contributions}
                                                setData={setContributions}
                                            />
                                        ))
                                    }
                                </tbody>
                                <tfoot>
                                    <tr>
                                    </tr>
                                </tfoot>
                            </table>
                        </div>
                    </div>
                    <div className='modal_actions'>
                        <div className='modal_buttons'>
                            <div className='modal_buttoncontainer'>
                                <button className='modal_button' onClick={() => handleAddContribtion(contributions, setContributions)}>Add row</button>
                            </div>
                            <div className='modal_buttoncontainer'></div>
                        </div>
                    </div>
                </div>
                <div className='modal_actions'>
                    {result && <div className='modal_result'>{result}</div>}
                    <div className='modal_buttons'>
                        <div className='modal_buttoncontainer'>
                            <button className="modal_button" onClick={() => addPayslip(project, ts, staffid, currencyid, name, earnings, deductions, contributions, liabilityaccountid, setLoading, setResult)}>Add</button>
                        </div>
                        <div className='modal_buttoncontainer'>
                            <button className="modal_button" onClick={closeButton}>Cancel</button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    function EditPayslip({ payslip, mode }) {
        const [id, setId] = useState('');

        const [selecteddate, setSelecteddate] = useState(new Date());
        const [ts, setTs] = useState(0);
        const [name, setName] = useState('');

        const [staffid, setStaffid] = useState('');
        const [earnings, setEarnings] = useState([]);
        const [deductions, setDeductions] = useState([]);
        const [contributions, setContributions] = useState([]);
        const [liabilityaccountid, setLiabilityaccountid] = useState('');

        const [currencyid, setCurrencyid] = useState('');

        const [result, setResult] = useState(null);
        const [loading, setLoading] = useState(false);

        useEffect(() => {
            const unixTimestamp = Math.floor(selecteddate.getTime() / 1000);
            setTs(unixTimestamp);
        }, [selecteddate]);

        useEffect(() => {
            setId(payslip.id);
            setTs(payslip.ts);
            setSelecteddate(new Date(payslip.ts * 1000));
            setStaffid(payslip.staffid);
            setCurrencyid(payslip.currencyid);
            setName(payslip.name);
            setEarnings(payslip.earnings);
            setDeductions(payslip.deductions);
            setContributions(payslip.contributions);
            setLiabilityaccountid(payslip.liabilityaccountid)
        }, [payslip]);

        return (
            <div className='modal_body'>
                <div className='modal_printable'>
                    <div className="modal_row">
                        <div className='modal_rowsection'>
                            <div className='modal_label'>Date</div>
                        </div>
                        <div className='modal_rowsection'>
                            <DatePicker
                                className='modal_datepicker'
                                selected={selecteddate}
                                onChange={(date) => setSelecteddate(date)}
                                dateFormat="dd/MM/yyyy"
                            />
                        </div>
                    </div>
                    <div className="modal_row">
                        <div className='modal_rowsection'>
                            <div className='modal_label'>Staff</div>
                        </div>
                        <div className='modal_rowsection'>
                            <Select data={project.staff} itemid={staffid} setItemid={setStaffid} />
                        </div>
                    </div>
                    <div className="modal_row">
                        <div className='modal_rowsection'>
                            <div className='modal_label'>Name</div>
                        </div>
                        <div className='modal_rowsection'>
                            <input
                                className='modal_input'
                                type="text"
                                value={name}
                                onChange={e => setName(e.target.value)}
                            />
                        </div>
                    </div>
                    <div className="modal_row">
                        <div className='modal_rowsection'>
                            <div className='modal_label'>Liability account</div>
                        </div>
                        <div className='modal_rowsection'>
                            <Select data={project.liabilityaccounts} itemid={liabilityaccountid} setItemid={setLiabilityaccountid} />
                        </div>
                    </div>
                    <div className="modal_row">
                        <div className='modal_rowsection'>
                            <div className='modal_label'>Earnings</div>
                        </div>
                    </div>
                    <div className="modal_row">
                        <div className='modal_rowsection'>
                            <table className='modal_table'>
                                <thead><tr><th>Type</th><th>Account</th><th>Amount</th><th></th></tr></thead>
                                <tbody>
                                    {
                                        earnings.map((row, index) => (
                                            <NewRow
                                                key={'earning' + index}
                                                row={row}
                                                index={index}
                                                data={earnings}
                                                setData={setEarnings}
                                            />
                                        ))
                                    }
                                </tbody>
                                <tfoot>
                                    <tr>
                                    </tr>
                                </tfoot>
                            </table>
                        </div>
                    </div>
                    <div className='modal_actions'>
                        <div className='modal_buttons'>
                            <div className='modal_buttoncontainer'>
                                <button className='modal_button' onClick={() => handleAddEarning(earnings, setEarnings)}>Add row</button>
                            </div>
                            <div className='modal_buttoncontainer'></div>
                        </div>
                    </div>
                    <div className="modal_row">
                        <div className='modal_rowsection'>
                            <div className='modal_label'>Deductions</div>
                        </div>
                    </div>
                    <div className="modal_row">
                        <div className='modal_rowsection'>
                            <table className='modal_table'>
                                <thead><tr><th>Type</th><th>Account</th><th>Amount</th><th></th></tr></thead>
                                <tbody>
                                    {
                                        deductions.map((row, index) => (
                                            <NewRow
                                                key={'deduction' + index}
                                                row={row}
                                                index={index}
                                                data={deductions}
                                                setData={setDeductions}
                                            />
                                        ))
                                    }
                                </tbody>
                                <tfoot>
                                    <tr>
                                    </tr>
                                </tfoot>
                            </table>
                        </div>
                    </div>
                    <div className='modal_actions'>
                        <div className='modal_buttons'>
                            <div className='modal_buttoncontainer'>
                                <button className='modal_button' onClick={() => handleAddDeduction(deductions, setDeductions)}>Add row</button>
                            </div>
                            <div className='modal_buttoncontainer'></div>
                        </div>
                    </div>
                    <div className="modal_row">
                        <div className='modal_rowsection'>
                            <div className='modal_label'>Contributions</div>
                        </div>
                    </div>
                    <div className="modal_row">
                        <div className='modal_rowsection'>
                            <table className='modal_table'>
                                <thead><tr><th>Type</th><th>Account</th><th>Amount</th><th></th></tr></thead>
                                <tbody>
                                    {
                                        contributions.map((row, index) => (
                                            <NewRow
                                                key={'contribution' + index}
                                                row={row}
                                                index={index}
                                                data={contributions}
                                                setData={setContributions}
                                            />
                                        ))
                                    }
                                </tbody>
                                <tfoot>
                                    <tr>
                                    </tr>
                                </tfoot>
                            </table>
                        </div>
                    </div>
                    <div className='modal_actions'>
                        <div className='modal_buttons'>
                            <div className='modal_buttoncontainer'>
                                <button className='modal_button' onClick={() => handleAddContribtion(contributions, setContributions)}>Add row</button>
                            </div>
                            <div className='modal_buttoncontainer'></div>
                        </div>
                    </div>
                </div>
                <div className='modal_actions'>
                    <div className='modal_buttons'>
                        <div className='modal_buttoncontainer'>
                            {mode === 'edit' && <button className="modal_button" onClick={() => updatePayslip(project, id, ts, staffid, currencyid, name, earnings, deductions, contributions, liabilityaccountid, setLoading, setResult)} disabled={loading}>{loading ? 'Loading...' : 'Update'}</button>}
                            {mode === 'clone' && <button className="modal_button" onClick={() => addPayslip(project, ts, staffid, currencyid, name, earnings, deductions, contributions, liabilityaccountid, setLoading, setResult)} disabled={loading}>{loading ? 'Loading...' : 'Save'}</button>}
                        </div>
                        {
                            mode === 'edit' &&
                            <div className='modal_buttoncontainer'>
                                <button className="modal_button" onClick={() => removeButton(payslip)}>Remove</button>
                            </div>
                        }
                        <div className='modal_buttoncontainer'>
                            <button className="modal_button" onClick={closeButton}>Cancel</button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    function RemovePayslip({ payslip }) {
        const [id, setId] = useState('');

        const [result, setResult] = useState(null);
        const [loading, setLoading] = useState(false);

        useEffect(() => {
            setId(payslip.id);
        }, [payslip]);

        return (
            <div className='modal_body'>
                <div className='modal_printable'>
                    <div className='modal_actions'>
                        {result && <div className='modal_result'>{result}</div>}
                        <div className='modal_buttons'>
                            <div className='modal_buttoncontainer'>
                                <button className="modal_button" onClick={() => removePayslip(project, id, setLoading, setResult)} disabled={loading}>{loading ? 'Loading...' : 'Remove'}</button>
                            </div>
                            <div className='modal_buttoncontainer'>
                                <button className="modal_button" onClick={closeButton}>Cancel</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    function ViewPayslip({ payslip }) {
        const printRef = useRef();

        const [id, setId] = useState('');
        const [ts, setTs] = useState(0)
        const [name, setName] = useState('');
        const [staffid, setStaffid] = useState('');
        const [currencyid, setCurrencyid] = useState('');
        const [earnings, setEarnings] = useState([]);
        const [deductions, setDeductions] = useState([]);
        const [contributions, setContributions] = useState([]);

        useEffect(() => {
            setId(payslip.id)
            setTs(payslip.ts)
            setName(payslip.name)
            setStaffid(payslip.staffid)
            setCurrencyid(payslip.currencyid)
            setEarnings(payslip.earnings)
            setDeductions(payslip.deductions)
            setContributions(payslip.contributions)
        }, [payslip]);

        const currencySymbol = project.currencies.find(curr => curr.id == currencyid)?.symbol
        const currencyName = project.currencies.find(curr => curr.id == currencyid)?.name
        const totalEarnings = earnings.reduce((sum, item) => sum + parseFloat(item.amount || 0), 0);
        const totalDeductions = deductions.reduce((sum, item) => sum + parseFloat(item.amount || 0), 0);
        const totalContributions = contributions.reduce((sum, item) => sum + parseFloat(item.amount || 0), 0);

        const net = totalEarnings - totalDeductions;

        return (
            <div className='modal_body'>
                <div className='modal_printable' ref={printRef}>
                    <div className='modal_row modal_center'>
                        <div className='modal_rowsection'>
                        </div>
                        <div className='modal_rowsection'>
                            <div className='modal_printabletitle'>PAYSLIP</div>
                        </div>
                        <div className='modal_rowsection'>
                            {project.projectdetails}
                        </div>
                    </div>
                    <div className='modal_row'>
                        <div className='modal_rowsection'>
                            <div className='modal_label'>Project Name</div>
                        </div>
                        <div className='modal_rowsection'>{project.name}</div>
                    </div>
                    <div className='modal_row'>
                        <div className='modal_rowsection'>
                            <div className='modal_label'>ID</div>
                        </div>
                        <div className='modal_rowsection'>{id}</div>
                    </div>
                    <div className='modal_row'>
                        <div className='modal_rowsection'>
                            <div className='modal_label'>Date</div>
                        </div>
                        <div className='modal_rowsection'>{moment.unix(ts).format('D MMMM YYYY')}</div>
                    </div>
                    <div className='modal_row'>
                        <div className='modal_rowsection'>
                            <div className='modal_label'>Staff</div>
                        </div>
                        <div className='modal_rowsection'>{project.staff.find((staff) => staff.id == staffid)?.name}</div>
                    </div>
                    <div className='modal_row'>
                        <div className='modal_rowsection'>
                            <div className='modal_label'>Name</div>
                        </div>
                        <div className='modal_rowsection'>{name}</div>
                    </div>
                    <table className="modal_table">
                        <thead>
                            <tr>
                                <th>Description</th>
                                <th>Amount</th>
                            </tr>
                        </thead>

                        <tbody>
                            {earnings.length > 0 && (
                                <>
                                    <tr>
                                        <td colSpan={2} className="modal_label">Earnings</td>
                                    </tr>
                                    {earnings.map((row, index) => (
                                        <tr key={'earning' + index}>
                                            <td>{row.name || ''}</td>
                                            <td>{currencySymbol} {row.amount}</td>
                                        </tr>
                                    ))}
                                </>
                            )}

                            {
                                deductions.length > 0 && (
                                    <>
                                        <tr>
                                            <td colSpan={2} className="modal_label">Deductions</td>
                                        </tr>
                                        {deductions.map((row, index) => (
                                            <tr key={'deduction' + index}>
                                                <td>{row.name || ''}</td>
                                                <td>{currencySymbol} {row.amount}</td>
                                            </tr>
                                        ))}
                                    </>
                                )
                            }

                            <tr>
                                <td><strong>Net Pay</strong></td>
                                <td><strong>
                                    {currencySymbol} {net} — {numberToWords(net)} {currencyName}
                                </strong></td>
                            </tr>
                        </tbody>
                    </table>
                    <div className='modal_row payslips_signatures'>
                        <div className='modal_rowsection'>
                            <div className='transactions_signature'></div>
                        </div>
                        <div className='modal_rowsection'></div>
                        <div className='modal_rowsection'>
                            <div className='transactions_signature'></div>
                        </div>
                    </div>
                    <div className='modal_row'>
                        <div className='modal_rowsection'>
                            <div className='modal_center'>Approved by</div>
                        </div>
                        <div className='modal_rowsection'></div>
                        <div className='modal_rowsection'>
                            <div className='modal_center'>Employee signature {moment.unix(payslip.ts).format('dddd, Do MMMM YYYY')}</div>
                        </div>
                    </div>
                </div>
                <div className='modal_actions'>
                    <div className='modal_buttons'>
                        <div className='modal_buttoncontainer'>
                            <ReactToPrint
                                trigger={() => (<button className="modal_button">Print</button>)}
                                content={() => printRef.current}
                            />
                        </div>
                        <div className='modal_buttoncontainer'>
                            <button className="modal_button" onClick={() => cloneButton(payslip)}>Clone</button>
                        </div>
                        <div className='modal_buttoncontainer'>
                            <button className="modal_button" onClick={closeButton}>Cancel</button>
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    return (
        <div className='payslips'>
            <Title text='Payslips' />

            <div className='buttonscontainer'>
                <div className='buttonsection'>
                    <button className='button' onClick={addButton}>Add Payslip</button>
                </div>
                <div className='buttonsection'>
                    <input
                        className='input'
                        type="text"
                        placeholder="Search"
                        value={search}
                        onChange={(e) => setSearch(e.target.value)}
                    />
                </div>
            </div>

            <table className='table'>
                <thead>
                    <tr>
                        <th></th>
                        <th></th>
                        <th>Date</th>
                        <th>Staff</th>
                        <th>Name</th>
                        <th>Value</th>
                    </tr>
                </thead>
                <tbody>
                    {
                        filteredpayslips.sort((a, b) => b.ts - a.ts).map((payslip, index) => {
                            let currencySymbol = project.currencies.find((curr) => curr.id == payslip.currencyid)?.symbol
                            return (
                                <tr className='table' key={'payslip' + index}>
                                    <td><div className='table_button' onClick={() => editButton(payslip)}>Edit</div></td>
                                    <td><div className='table_button' onClick={() => viewButton(payslip)}>View</div></td>
                                    <td><div>{moment.unix(payslip.ts).format('D/MMM/YYYY')}</div></td>
                                    <td><div>{payslip.staffid}</div></td>
                                    <td><div>{payslip.name}</div></td>
                                    <td><div>{currencySymbol} {payslip.amount}</div></td>
                                </tr>
                            );
                        })}
                </tbody>
            </table>
        </div>
    );
}

export default Payroll;